import { motion } from "framer-motion";
import FeaturedWork from "../components/FeaturedWork";
import Intro from "../components/Intro";
import Banner from "../components/Banner";
import Scroll from "../components/Scroll";
import Footer from "../components/Footer";
import Faq from "../components/Faq";
import Award from "../components/Award";

const Home = () => {
  return (
    <motion.div
      className="home"
      initial={{ opacity: 0, z: 100 }}
      animate={{ opacity: 1, z: 0 }}
      exit={{ opacity: 0, z: -100 }}
      transition={{ duration: 0.5, delay: 0.15 }}
    >
      <Award />
      <div className="hero">
        <div className="title">
          <Banner text={`Andrew ${"\xa0".repeat(3)} Dikianidis`} isHero />
        </div>
        <motion.div
          className="job-title"
          initial={{ opacity: 0, z: 100 }}
          animate={{ opacity: 1, z: 0 }}
          exit={{ opacity: 0, z: -100 }}
          transition={{ duration: 0.5, delay: 1.5 }}
        >
          <p>
            Creative
            <br />
            Software Engineer {"&"}
            <br />
            Designer
          </p>
        </motion.div>
        <div className="hero-scroll">
          <Scroll />
        </div>
      </div>
      <Intro />
      <FeaturedWork />
      <motion.div
        className="page-bottom-sections"
        initial={{
          opacity: 0.75,
          clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
        }}
        whileInView={{
          opacity: 1,
          clipPath: "polygon(0% 100%, 100% 100%, 100% 0%, 0% 0%)",
        }}
        transition={{ duration: 0.5 }}
      >
        <Faq />
        <Footer />
      </motion.div>
    </motion.div>
  );
};

export default Home;
